import { c as _c } from "react/compiler-runtime";
import { Button } from '../ui/button';
import { DiscordButton } from '../logos/DiscordButton';
export const NoActivitiesHero = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h1 className="text-2xl font-bold">No activities yet</h1>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <a href="https://vodojo-releases.s3.us-east-1.amazonaws.com/vodojo/win32/x64/vodojo-latest.exe"><Button variant="secondary" size="lg">Download the app to start recording!</Button></a>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-center justify-center gap-4 ">{t0}{t1}<div>Not sure what to do? Get help on our Discord! <DiscordButton /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};